// Extracts the Spreadsheet ID from a Google Spreadsheet URL
export function extractSpreadsheetId(url: string): string | null {
    // Handles URLs like:
    // https://docs.google.com/spreadsheets/d/ID/edit#gid=0
    // https://docs.google.com/spreadsheets/d/ID/
    // https://docs.google.com/spreadsheets/d/ID
    const match = url.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/)
    return match ? match[1] : null
}

export type SpreadsheetTabProperties = {
    title: string
    gridProperties: {
        rowCount: number
        columnCount: number
    }
}

export type SpreadsheetTab = {
    properties: SpreadsheetTabProperties
}

export type SpreadsheetApiResponse = {
    properties: {
        title: string
    }
    sheets: SpreadsheetTab[]
}

export type SpreadsheetApiError = {
    error: {
        code: number
        message: string
        status: string
    }
}

export const getSpreadsheetApiData = async (spreadsheetId: string) => {
    const apiKey = process.env.GOOGLE_SHEET_API_KEY
    if (!apiKey) {
        throw new Error('Google API key is not configured on the server.')
    }

    const apiEndpoint = `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}?key=${apiKey}`
    const response = await fetch(apiEndpoint, { next: { revalidate: false } })
    const data = (await response.json()) as SpreadsheetApiResponse & SpreadsheetApiError

    if (!response.ok) {
        const errorMessage = data.error?.message || 'Failed to fetch Google Spreadsheet data.'
        if (errorMessage.includes('permission')) {
            throw new Error('This Google Spreadsheet is not public. Please make it accessible to "Anyone with the link" as a "Viewer".')
        }
        throw new Error(errorMessage)
    }

    return data
}
